import Concrete from './imgs/accconcrete.png';

const ConcreteData = [
    {
        id:"1",
        imgsrc: Concrete,
        title: "500D TMT Bar",
        qty: "1kg",
        cost: "₹10.00"
    },
    {
        id:"2",
        imgsrc: Concrete,
        title: "500D TMT Bar",
        qty: "1kg",
        cost: "₹10.00"
    },
    {
        id:"3",
        imgsrc: Concrete,
        title: "500D TMT Bar",
        qty: "1kg",
        cost: "₹10.00"
    },
    {
        id:"4",
        imgsrc: Concrete,
        title: "500D TMT Bar",
        qty: "1kg",
        cost: "₹10.00"
    },
    {
        id:"5",
        imgsrc: Concrete,
        title: "500D TMT Bar",
        qty: "1kg",
        cost: "₹10.00"
    },
    {
        id:"6",
        imgsrc: Concrete,
        title: "500D TMT Bar",
        qty: "1kg",
        cost: "₹10.00"
    },
    {
        id:"7",
        imgsrc: Concrete,
        title: "500D TMT Bar",
        qty: "1kg",
        cost: "₹10.00"
    },
    {
        id:"8",
        imgsrc: Concrete,
        title: "500D TMT Bar",
        qty: "1kg",
        cost: "₹10.00"
    },
    {
        id:"9",
        imgsrc: Concrete,
        title: "500D TMT Bar",
        qty: "1kg",
        cost: "₹10.00"
    },
    {
        id:"10",
        imgsrc: Concrete,
        title: "500D TMT Bar",
        qty: "1kg",
        cost: "₹10.00"
    },
];
export default ConcreteData;